import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  withMobileDialog,
  Divider,
  Button,
  IconButton,
  Icon,
  Drawer,
} from '@material-ui/core';
import { connect } from 'react-redux';
import {
  setDashboardFilter,
  toggleDashboardFilter as toggleDashboardFilterAction,
} from '@pingum/app-state-management/dashboard/actions';
import FilterStatus from '../FilterStatus';
import FilterEvent from '../FilterEvent';
import FilterTags from '../FilterTags';
import styles from './styles';

export class DashboardFilterComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { searchEvents: this.props.currentFilterDashboard.dashboardData };
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentFilterDashboard && this.props.currentFilterDashboard.dashboardData
      && prevProps.currentFilterDashboard.id !== this.props.currentFilterDashboard.id) {
      this.setState({ searchEvents: this.props.currentFilterDashboard.dashboardData });
    }
  }

  updateSearchEventsState = (data, field) => {
    this.setState((prevState) => {
      const newSearchEvents = prevState.searchEvents || {};
      newSearchEvents[field] = data;
      // newSearchEvents.includeComplete = newSearchEvents.includeComplete || false;
      // newSearchEvents.includeArchived = newSearchEvents.includeArchived || false;
      return { searchEvents: newSearchEvents };
    });
  }

  handleCloseFilter = () => {
    this.props.toggleDashboardFilter(false);
  }

  handleEnter = () => {
    this.applyFilter();
  }

  applyFilter = () => {
    this.props.applyFilterToSearch(this.state.searchEvents, true, true);
    this.props.currentFilterDashboard.dashboardData = this.state.searchEvents;
    this.props.setDashboardFilter(this.props.currentFilterDashboard);
    this.handleCloseFilter();
  }

  render() {
    const {
      classes,
      open,
      fullScreen,
    } = this.props;
    let drawerClass;
    if (!open) {
      drawerClass = classes.drawerClose;
    } else if (fullScreen) {
      drawerClass = classes.drawerOpenFullScreen;
    } else {
      drawerClass = classes.drawerOpen;
    }

    return (
      <Drawer
        variant="temporary"
        anchor="right"
        className={drawerClass}
        classes={{ paper: drawerClass }}
        open={open}
        onClose={this.handleCloseFilter}
      >
        {
          open
            && (
              <div
                className={fullScreen
                  ? classes.containerFullScreen
                  : classes.container}
              >
                <div
                  id="filter-title"
                  className={classes.containerTitle}
                >
                  <h5 className={classes.title}>Filter</h5>
                  <div>
                    <IconButton
                      onClick={this.handleCloseFilter}
                      color="inherit"
                    >
                      <Icon className={classes.close}>close</Icon>
                    </IconButton>
                  </div>
                </div>
                <Divider />
                <div className={classes.gridRoot}>
                  <FilterEvent
                    updateSearchEventsState={this.updateSearchEventsState}
                    onEnter={this.handleEnter}
                  />
                  <Divider />
                  <FilterStatus updateSearchEventsState={this.updateSearchEventsState} />
                  <FilterTags updateSearchEventsState={this.updateSearchEventsState} />
                </div>

                <Divider />
                <div className={classes.footer}>
                  <Button
                    onClick={this.handleCloseFilter}
                    color="default"
                    name="cancel-button"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={this.applyFilter}
                    color="primary"
                    name="apply-button"
                    variant="contained"
                  >
                    Apply
                  </Button>
                </div>
              </div>
            )
        }
      </Drawer>
    );
  }
}

DashboardFilterComponent.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  currentFilterDashboard: PropTypes.any,
  applyFilterToSearch: PropTypes.func,
  toggleDashboardFilter: PropTypes.func,
  setDashboardFilter: PropTypes.func,
  fullScreen: PropTypes.bool,
};

DashboardFilterComponent.defaultProps = {
  classes: {},
  open: false,
  currentFilterDashboard: {},
  applyFilterToSearch: () => {},
  toggleDashboardFilter: () => {},
  setDashboardFilter: () => {},
  fullScreen: false,
};

export const mapStateToProps = (state) => ({
  currentFilterDashboard: { ...state.dashboard.currentFilterDashboard },
  open: state.dashboard.showDashboardFilter,
});

export const mapDispatchToProps = (dispatch) => ({
  setDashboardFilter: (dashboard) => dispatch(setDashboardFilter(dashboard, false)),
  toggleDashboardFilter: () => dispatch(toggleDashboardFilterAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobileDialog({ breakpoint: 'xs' })(withStyles(styles, { withTheme: true })(DashboardFilterComponent)));
